module.exports = __webpack_public_path__ + "b86b8f8d8fe356fd6669dbf6b360a448.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-5.png
// module id = 2112
// module chunks = 0